import React, { memo, forwardRef } from 'react';
import { View, TextInput as RNTextInput } from 'react-native';
import { Text } from '@redlink/components/atoms';
import { createUseStyle } from '@redlink/assets/styles';
import { useMask } from './useMask';

export const TextInputPreview = memo(
  forwardRef(
    (
      {
        style,
        title,
        prefix,
        postfix,
        mask,
        en = false,
        onChangeText: onChangeTextOrigin,
        editable = true,
        multiline,
        value: originText = '',
        textStyle,
        require = false,
        ...restProps
      },
      ref
    ) => {
      const { styles } = useStyle();
      const { getUpdatedValue, getRawValue } = useMask(mask);
      const onChangeText = (rawValue) => {
        const updatedValue = mask
          ? getUpdatedValue(rawValue, rawValue)
          : rawValue;
        const originValue = mask ? getRawValue(updatedValue) : rawValue;
        onChangeTextOrigin && onChangeTextOrigin(originValue, updatedValue);
      };
      const value = mask ? getUpdatedValue(originText, originText) : originText;
      return (
        <View style={[styles.container, style]}>
          <Text style={[styles.titleText]}>
            {title}
            {require && <Text style={styles.requireText}>*</Text>}
          </Text>
          <View style={styles.inputContainer}>
            {prefix && (
              <Text {...{ en }} style={styles.prefixText}>
                {prefix}
              </Text>
            )}
            <RNTextInput
              {...{ ref }}
              {...restProps}
              style={[
                styles.text,
                textStyle,
                !en && styles.textFontFamily,
                multiline && styles.multilineText,
              ]}
              {...{ onChangeText, editable, multiline, value }}
            />
            {postfix && (
              <Text {...{ en }} style={styles.prefixText}>
                {postfix}
              </Text>
            )}
          </View>
        </View>
      );
    }
  )
);

const useStyle = createUseStyle(({ colors, ltrFlexDirection, language }) => ({
  container: {
    backgroundColor: colors.cardBackground,
    borderBottomWidth: 2,
    paddingBottom: 10,
    paddingTop: 10,
    paddingHorizontal: 9,
    borderTopRightRadius: 4,
    borderTopLeftRadius: 4,
    borderBottomColor: colors.subtitle,
  },
  text: {
    flex: 1,
    fontSize: 14,
    color: colors.title,
  },
  textFontFamily: {
    ...(language === 'fa' && { fontFamily: 'dana' }),
    fontSize: 16,
  },
  titleText: {
    fontSize: 10,
    color: colors.subtitle,
  },
  inputContainer: {
    flexDirection: ltrFlexDirection,
    alignItems: 'center',
  },
  prefixText: {
    color: colors.gray21,
    paddingHorizontal: 5,
  },
  multilineText: {
    minHeight: 100,
  },
  requireText: {
    color: colors.red1,
    fontSize: 10,
    marginStart: 5,
  },
}));
